export default __webpack_public_path__ + "static/media/Payment-yes-02.b7f4ae5c.svg";